// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/partials/_index.scss
// module id = 78
// module chunks = 0